import React from 'react';

import {errorRed, grey} from '../assets/colors';

//region Access Key

const accessKeySuccessfullyAssignedText = 'Access key has been successfully assigned.';

//endregion

//region Account

const loadAccountInfoErrorText = 'Failed to load account information.';
const businessAddressUnauthorized = 'You do not have permission to edit or delete business addresses. Contact staff for help.';
const personalAccountCreationInstruction = 'I am opening an account for an individual.';
const businessAccountCreationInstruction = 'I am opening an account for an organization or business.';
const accountCreationInstruction = 'To create an account, select an account type to continue. After account creation, this choice is permanent.';
const accountCreationCheckBoxError = <p style={{color: errorRed}}>Please acknowledge before proceeding.</p>;
const accountCreationSelectBoxError = <p style={{color: errorRed}}>Please select account type before proceeding.</p>;
const accountCreationSelectMemberError = <p style={{color: errorRed}}>Please select a member before proceeding.</p>;
const accountCreated = 'The account has been successfully created.';
const accountCreatedButNotLoaded = 'The account was created but could not be loaded. Please manually switch to this member.';
const accountCreatedAndLoaded = 'The account has been successfully created and a verification email has been sent to the member.';
const notMatchingPassword = 'The two passwords that you entered do not match!';
const accountCreationConfirmation = 'I understand that this choice is permanent and cannot be changed in the future.';
const accountDetailsUpdated = 'Account details have been updated.';

//endregion

//region Billing

const accountingBalanceTextStaff = 'The sum of all reconciled/invoiced payment transactions, ' +
    'or any transaction that has appeared on an invoice.';

const accountingBalanceTextMember = 'A positive balance means the amount of money owing that has appeared on an invoice. ' +
    'A negative balance means there is account credit available for use.';

const chargeCreatePostTaxDisclaimer = 'Each field will recalculate automatically when tax rate(s) are selected. ' +
    'Due to rounding, amounts may not add up precisely to the totals and tax(es) provided.';

const chargeCreateSuccessMessage = 'Charge has been successfully added.';
const chargeUpdateSuccessMessage = 'Charge has been updated to reflect the change.';
const chargeDeleteSuccessMessage = 'Charge has been successfully removed.';
const estimatedCostsText = 'Estimated cost only includes the time charge, applicable taxes, and promo(s). The distance charge will be added to this cost once you complete the trip.';
const payableBalanceText = 'The amount of money owing past its payable date.';
const depositBalanceText = 'The amount of current deposit value.';
const totalCostsText = 'This is the total cost of your booking and includes both the time charge and distance charge, plus applicable taxes and promos.';
const greaterThanOrEqualZero = 'Please enter an amount greater than or equal to 0.';
const greaterThanZero = 'Please enter an amount greater than 0.';
const greaterThanOrEqualOne = 'Please enter an amount greater than or equal to 1.';
const wholeNumberGreaterOrEqualToOne = 'Please enter a whole number greater than or equal to 1';

//endregion

//region Country text

const GSTRegistrationNumberText = 'GST/HST Number';
const TaxRegistrationNumberText = 'Tax Registration Number';

//endregion

//region Mass Email

const massEmailDisclaimerText = <span style={{color: grey}}>Engage is located in Canada, and all email you send through Engage is subject to <a
    href="https://fightspam.gc.ca/eic/site/030.nsf/eng/home" target="_blank" rel="noopener noreferrer">Canada's Anti-Spam Legislation</a>. If you use this feature to send marketing content, then please be aware that some members may not have opted into marketing emails.</span>;

//endregion

//region Transaction History

const emptyTransactionHistoryText = 'No results found. Please adjust your search and try again.';

//endregion

//region Report

const accountingBalanceHistoryReportInstructionText = 'This will generate a historical accounting balance report for all accounts within the specified period of time.';
const shareBalanceHistoryReportInstructionText = 'This will generate a historical share balance report for all people/companies within the specified period of time.';
const depositBalanceHistoryReportInstructionText = 'This will generate a historical deposit balance report for all accounts within the specified period of time.';
const depositTransactionHistoryReportInstructionText = 'This will generate a historical deposit transaction report for all accounts within the specified period of time.';
const shareTransactionHistoryReportInstructionText = 'This will generate a historical share transaction report for all people/companies within the specified period of time.';
const bookingHistoryReportInstructionText = 'This will generate a historical booking report for all accounts within the specified period of time.';
const accountRevenueReportInstructionText = 'This will generate a historical revenue by account report within the specified period of time. Revenue is defined as Charge & Credit transactions include fines, fees, reimbursements, and credits. As well as Booking transactions.';
const accountPaymentReportInstructionText = 'This will generate a historical payment by account report within the specified period of time. Payment transactions include payments, refunds, write-offs, etc.';
const paymentByTypeReportInstructionText = 'This will generate a historical payment by type report within the specified period of time. Payment types include payments or refunds as a category. As a subcategory: cash, cheque, debit card, and credit card.';
const revenueByTypeReportInstructionText = 'This will generate a historical revenue by type report within the specified period of time. Revenue types include bookings or charges as a category. As a subcategory: adjustment, fine, fee, and membership.';
const rcsBookingsInstructionText = "This will generate a report of the previous month's bookings and related information."
const ctgInvoicesInstructionText = "This will generate a report for the previous month's invoice data."
const ctgTaxesInstructionText = "This will generate a report of the previous month's taxes for bookings and charges."
const accountBalanceEmptyReportText =  'Include accounts with a running balance of 0 during this period of time ?';
const shareBalanceEmptyReportText = 'Include people/companies with a running balance of 0 during this period of time ?';
const depositTransactionEmptyReportText = 'Include accounts with running transactions of 0 during this period of time ?';
const shareTransactionEmptyReportText = 'Include people/companies with running transactions of 0 during this period of time ?';
const accountRevenuePaymentEmptyReportText = 'Include accounts with no transactions during this period of time ?';

//endregion

//region Booking Details
const startTimeCannotBeExtended = 'Start time cannot be extended.';
const startTimeCannotBeExtendedDueToUnavailability = 'Start time cannot be extended due to unavailability.';
const endTimeCannotBeExtended = 'End time cannot be extended.';
const endTimeCannotBeExtendedDueToUnavailability = 'End time cannot be extended due to unavailability.';
const endTimeCanBeExtendedIndefinitely = 'End time can be extended indefinitely.';
const startTimeCanBeExtendedTo = (time) => `Start time can be extended to ${time}`;
const endTimeCanBeExtendedTo = (time) => `End time can be extended to ${time}`;
const startTimeHasToBeEarlierThanEndTime = 'Start time has to be earlier than end time!';
const startTimeCannotBeInThePast = 'Start Time cannot be in the past!';
const endTimeCannotBeInThePast = 'End Time cannot be in the past!';
const bookingDetailsHaveSuccessfullyBeenUpdated = 'Booking details have successfully been updated.';
const cancelledBookingCannotBeModified = 'Cancelled booking cannot be modified!';
const unsupportedBookingType = 'Unsupported booking type.';
const nothingToUpdate = 'Nothing to update!';

//endregion

//region CalendarView

const bookingOverlapAnotherBooking = 'This booking overlaps with another booking.';
const newBookingsCannotBeInThePastOrOverlapExistingBookings = 'New bookings cannot be in the past or overlap existing bookings.';
const availabilityHasChangedAndYourSelectionIsNoLongerValid = 'Availability has changed and your selection is no longer valid.';
const invalidActionPleaseTryAgain = 'Invalid action, please try again.';

//endregion

//region Payments

const noCreditCardOnFile = <span style={{color: grey}}>No credit card on file</span>
const createPaymentRecord = <p style={{color: grey}}>Create a database record of a payment without charging the
    member.</p>
const creditcardPayment = <p style={{color: grey}}>Make a payment with a stored credit card.</p>

//endregion

//region Refunds

const createRefundRecord = <p style={{color: grey}}>Create a database record of a refund without charging the
    member.</p>

//endregion

//region Deposits

const emptyDepositsHistoryText = 'You have not made any deposits.';
const reduceWhenNoDepositsText = 'Unable to reduce deposit as the account does not hold any deposits.';
const failTransactionText = 'We were not able to process your payment. Please try again.';
const currentDepositValue = <span>Current Deposit Value</span>;
const amountCurrentlyOwing = <span>Amount Currently Owing</span>;

//endregion

//region Jails

const closeAccountDescription= 'This member will no longer have any permissions on the account. The account will remain open for invoicing and payment only until the balance is 0.';

const closeAccountTooltip = 'This action will add account closure restriction to the account. As soon as the balance is 0, the account will automatically transition into closed. In addition, this action will prohibit account members from creating and editing any future bookings.'
const revokeCreateBookingToolTip = 'This action will add a restriction by prohibiting the user from creating any future bookings. This will stay in effect until it is released by a staff member.';
const waiveMonthlyFeeToolTip = 'This action will waive the account\'s monthly fee. This will stay in effect until it is released by a staff member.';
const makeTaxExemptToolTip = 'This action will make an account tax exempt. This will stay in effect until it is released by a staff member.';
const deleteApplicantDescription = 'This action is permanent and cannot be reversed. The member will have to restart their application from scratch once their application is deleted.';
const deleteApplicantToolTip = 'This action will remove their online registration application permanently.';
const migrateToV7ToolTip = 'This action will send applicant information to Engage 7. You can only do this once.';
const cancelMemberBookingsToolTip = 'This action will cancel all future bookings for this membership and is irreversible.';
const carDetailsRateClassToolTip = 'Vehicle rate classes are only applicable to certain organizations. Please leave empty if not applicable.';
const carDetailsNickNameToolTip = 'If a vehicle nickname is provided, it will replace the vehicle number for display purposes. (this will only take effect at a later date, as it has not yet been implemented)';
const carDetailsVinToolTip = 'The vehicle VIN is required in order to deploy a vehicle. If you do not have this information now, please fill it in at a later date.';

const restrictionAddedByStaff = 'Restriction manually added by staff.';

const restrictionAppliedSuccessMessage = 'Restriction has been applied to this account.';
const waiveMonthlyFeeSuccessMessage = 'Future monthly fees will be waived.';
const taxExemptSuccessMessage = 'Account has been marked as tax exempt.';
const migrateToV7SuccessMessage = 'Member data has been successfully migrated to Engage 7.';
const closeAccountSuccessMessage = 'Pending closure restriction has been successfully added.';
const cancelMemberBookingsSuccessMessage = 'All future bookings for this membership have been cancelled.';
const vehicleNumberRuleMessage = 'Vehicle Number should be a positive number less or equal to 9 digits';
const changesSuccessfullySavedMessage = 'Your changes have been successfully saved!';

const migratedToV7IndicationBanner = (legacyNum, truncate) => {
    return truncate ? `Member data sent to Engage 7; continue managing account ${legacyNum ?? 'N/A'} there.` : `This applicant data has been sent to Engage 7 and can no longer be edited on Engage 8. Please go to Engage 7 to manage this member with the account number ${legacyNum ?? 'N/A'}.`;
}

//endregion

export {
    accessKeySuccessfullyAssignedText,
    accountingBalanceTextStaff,
    accountingBalanceTextMember,
    chargeCreatePostTaxDisclaimer,
    chargeCreateSuccessMessage,
    chargeUpdateSuccessMessage,
    chargeDeleteSuccessMessage,
    loadAccountInfoErrorText,
    businessAddressUnauthorized,
    personalAccountCreationInstruction,
    businessAccountCreationInstruction,
    accountCreationInstruction,
    accountCreationCheckBoxError,
    accountCreationSelectBoxError,
    accountCreationSelectMemberError,
    accountCreated,
    accountCreatedButNotLoaded,
    accountCreatedAndLoaded,
    notMatchingPassword,
    accountCreationConfirmation,
    accountDetailsUpdated,
    estimatedCostsText,
    payableBalanceText,
    depositBalanceText,
    totalCostsText,
    greaterThanOrEqualZero,
    greaterThanZero,
    greaterThanOrEqualOne,
    wholeNumberGreaterOrEqualToOne,
    GSTRegistrationNumberText,
    TaxRegistrationNumberText,
    massEmailDisclaimerText,
    emptyTransactionHistoryText,
    accountingBalanceHistoryReportInstructionText,
    shareBalanceHistoryReportInstructionText,
    shareTransactionHistoryReportInstructionText,
    depositTransactionHistoryReportInstructionText,
    accountPaymentReportInstructionText,
    accountRevenueReportInstructionText,
    bookingHistoryReportInstructionText,
    paymentByTypeReportInstructionText,
    revenueByTypeReportInstructionText,
    accountBalanceEmptyReportText,
    shareBalanceEmptyReportText,
    depositTransactionEmptyReportText,
    shareTransactionEmptyReportText,
    depositBalanceHistoryReportInstructionText,
    accountRevenuePaymentEmptyReportText,
    startTimeCannotBeExtended,
    startTimeCannotBeExtendedDueToUnavailability,
    endTimeCannotBeExtended,
    endTimeCannotBeExtendedDueToUnavailability,
    endTimeCanBeExtendedIndefinitely,
    startTimeCanBeExtendedTo,
    endTimeCanBeExtendedTo,
    startTimeHasToBeEarlierThanEndTime,
    startTimeCannotBeInThePast,
    endTimeCannotBeInThePast,
    bookingDetailsHaveSuccessfullyBeenUpdated,
    cancelledBookingCannotBeModified,
    unsupportedBookingType,
    nothingToUpdate,
    bookingOverlapAnotherBooking,
    newBookingsCannotBeInThePastOrOverlapExistingBookings,
    availabilityHasChangedAndYourSelectionIsNoLongerValid,
    invalidActionPleaseTryAgain,
    noCreditCardOnFile,
    createPaymentRecord,
    creditcardPayment,
    createRefundRecord,
    emptyDepositsHistoryText,
    reduceWhenNoDepositsText,
    failTransactionText,
    currentDepositValue,
    amountCurrentlyOwing,
    deleteApplicantDescription,
    closeAccountTooltip,
    deleteApplicantToolTip,
    revokeCreateBookingToolTip,
    restrictionAddedByStaff,
    waiveMonthlyFeeToolTip,
    makeTaxExemptToolTip,
    migrateToV7ToolTip,
    migrateToV7SuccessMessage,
    restrictionAppliedSuccessMessage,
    waiveMonthlyFeeSuccessMessage,
    taxExemptSuccessMessage,
    cancelMemberBookingsSuccessMessage,
    cancelMemberBookingsToolTip,
    closeAccountSuccessMessage,
    migratedToV7IndicationBanner,
    closeAccountDescription,
    rcsBookingsInstructionText,
    ctgTaxesInstructionText,
    ctgInvoicesInstructionText,
    vehicleNumberRuleMessage,
    carDetailsRateClassToolTip,
    carDetailsNickNameToolTip,
    carDetailsVinToolTip,
    changesSuccessfullySavedMessage,
}
